import React, { useRef } from 'react';
import { FiEdit, FiPlus, FiTrash2 } from 'react-icons/fi';
import styled from 'styled-components';
import { HorizontalContent } from '../HorizontalContent';
import { RhButton, RhButtonMode } from '../RhButton';
import { RhCard } from '../RhCard';
import { RhImage } from '../RhImage';
import { SizedBox } from '../SizedBox';
import { H2 } from '../Styles';

type Props = {
  title?: string;
  value: File | null | undefined;
  /** For edit. To display image returned from the server */
  valueInUrl?: string | null;
  /** Called when the user edits the fields */
  onChange: (imageFile: File) => void;
  /** Called when the user clicks the Trash icon */
  onRemove?: () => void;
};

export const FeatureImageCard: React.FC<Props> = props => {
  const imageRef = useRef<HTMLInputElement>(null);

  return (
    <RhCard mode="tiled">
      <HorizontalContent
        left={<H2>{props.title || 'Feature Image'}</H2>}
        right={[
          <input
            key="image-input"
            type="file"
            hidden={true}
            accept="image/*"
            multiple={false}
            ref={imageRef}
            onChange={e => {
              const file = e.target.files?.[0];
              if (!file) return;
              props.onChange(file);
            }}
          />,
          <RhButton
            key="add-image-button"
            mode={RhButtonMode.subtle}
            prefixIcon={props.value ? FiEdit : FiPlus}
            iconSize={18}
            onClick={() => {
              imageRef.current?.click();
            }}
          />,
          props.value && (
            <RhButton
              key="remove-image-button"
              mode={RhButtonMode.subtle}
              prefixIcon={FiTrash2}
              iconSize={18}
              onClick={props.onRemove}
            />
          ),
        ]}
      />
      {props.value ? (
        <FeaturedImage src={URL.createObjectURL(props.value)} alt="Featured image" />
      ) : (
        !!props.valueInUrl && (
          <>
            <SizedBox height={12} />
            <RhImage style={{ aspectRatio: '16 / 9' }} mode="full" src={props.valueInUrl} />
          </>
        )
      )}
    </RhCard>
  );
};

const FeaturedImage = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 16px;
  object-fit: cover;
  margin-top: 12px;
`;
